import {
    Featured,
    GenresCarousel,
    ForYou,
    Toolbar,
    LibraryTabs,
    HubSwitch,
    FeaturedBpmOriginal,
    PromotionsMessagingModal,
    useLibraryTabs,
    TrendingBrowseSupreme,
    ExclusivePlaylistsBrowse,
    Title
} from '@bpm-web-app/components';
import { NewsCarousel, Banner, MessageBanner, AnonymousUserBanner } from '@bpm-web-app/components/shared';
import { useGenres } from '@bpm-web-app/swr-hooks';
import { useHubSwitch, useUserSettings } from '@bpm-web-app/utils';
import { useMemo, useState } from 'react';

export default function Index({ title }: { title: string }) {
    const { isDownload } = useHubSwitch();
    const { isAnonymous } = useUserSettings();
    const { libraryProperty, library } = useLibraryTabs();
    const [isBannersLoaded, setIsBannersLoaded] = useState(false);
    const [isFeaturedLoaded, setIsFeaturedLoaded] = useState(false);
    const [isExclusivePlaylistsLoaded, setIsExclusivePlaylistsLoaded] = useState(false);
    const [isTrendingLoaded, setIsTrendingLoaded] = useState(false);
    const [isForYouLoaded, setIsForYouLoaded] = useState(!(library !== 'artist' && !isAnonymous));
    const [isFeaturedBPMOriginalsLoaded, setIsFeaturedBPMOriginalsLoaded] = useState(!(library !== 'artist'));
    const [isNewsLoaded, setIsNewsLoaded] = useState(false);

    const { genres, isLoading } = useGenres(libraryProperty);

    const isEverythingLoaded = useMemo(() => {
        if (isAnonymous && isBannersLoaded &&
            isFeaturedLoaded &&
            isExclusivePlaylistsLoaded &&
            !isLoading &&
            isTrendingLoaded &&
            isFeaturedBPMOriginalsLoaded &&
            isNewsLoaded
        ) return true;
        if (isBannersLoaded &&
            isFeaturedLoaded &&
            isExclusivePlaylistsLoaded &&
            !isLoading &&
            isTrendingLoaded &&
            isForYouLoaded &&
            isFeaturedBPMOriginalsLoaded &&
            isNewsLoaded
        ) return true;

        return false;
    }, [isAnonymous, isBannersLoaded, isExclusivePlaylistsLoaded, isFeaturedBPMOriginalsLoaded, isFeaturedLoaded, isForYouLoaded, isLoading, isNewsLoaded, isTrendingLoaded]);

    return (
        <>
            <Title title={title} platform="download" />
            <Toolbar stickToHeader>
                <LibraryTabs />
                <HubSwitch />
            </Toolbar>
            {isAnonymous ? <MessageBanner type="info" title="You’re currently previewing BPM Supreme." viewPlanRoute /> : null}
            <Banner platform={isDownload ? 'download' : 'stream'} library={libraryProperty} isDataLoaded={isEverythingLoaded} setIsDataLoaded={setIsBannersLoaded} />
            <Featured isDataLoaded={isEverythingLoaded} setIsDataLoaded={setIsFeaturedLoaded} />
            <AnonymousUserBanner />
            {library !== 'artist' ? <ExclusivePlaylistsBrowse isDataLoaded={isEverythingLoaded} setIsDataLoaded={setIsExclusivePlaylistsLoaded} /> : null}
            <TrendingBrowseSupreme isDataLoaded={isEverythingLoaded} setIsDataLoaded={setIsTrendingLoaded} />
            {library !== 'artist' && !isAnonymous ? <ForYou isDataLoaded={isEverythingLoaded} setIsDataLoaded={setIsForYouLoaded} /> : null}
            {library !== 'artist' ? <FeaturedBpmOriginal isDataLoaded={isEverythingLoaded} setIsDataLoaded={setIsFeaturedBPMOriginalsLoaded} /> : null}
            <GenresCarousel genres={genres} isLoading={!isEverythingLoaded} />
            <NewsCarousel newsProviderId={process.env.NEXT_PUBLIC_MAIN_BPM_NEWS_PROVIDER_ID} isCreate={false} isDataLoaded={isEverythingLoaded} setIsDataLoaded={setIsNewsLoaded} />
            <PromotionsMessagingModal />
        </>
    );
}

export async function getStaticProps() {
    return {
        props: {
            title: 'Home'
        }
    };
}
